import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export const Auth = "auth";
export type Auth = typeof Auth;

export const SetAuthInfo = `${Auth}/setAuthInfo`;
export type SetAuthInfo = typeof SetAuthInfo;

export const InitiateCheckAuth = `${Auth}/initiateCheckAuth`;
export type InitiateCheckAuth = typeof InitiateCheckAuth;

export interface AuthInfo {
    username: string,
    password: string,
}

export interface AuthState {
    authInfo: AuthInfo | null,
    checkInProgress: boolean,
    checkPass: boolean | null,
    error: string | null
}

const initialState: AuthState = {
    authInfo: null,
    checkInProgress: false,
    checkPass: null,
    error: null
}

const authSlice = createSlice({
    name: Auth,
    initialState,
    reducers: {
        initiateCheckAuth: (state: AuthState, action: PayloadAction<AuthInfo>) => {
            state.checkInProgress = true;
            state.error = null;
            state.authInfo = action.payload;
            state.checkPass = null;
        },
        authCheckSuccess: (state: AuthState) => {
            state.checkInProgress = false;
            state.checkPass = true;
            state.error = null;
        },
        authCheckError: (state: AuthState, action: PayloadAction<string>) => {
            state.checkInProgress = false;
            state.checkPass = false;
            state.error = action.payload;
        }
    }
});

export const { initiateCheckAuth, authCheckSuccess, authCheckError } = authSlice.actions;
export default authSlice.reducer;